<script lang="ts" setup>
import { version } from '../../../package.json';

</script>

<template>
    <footer class="mt-8 flex h-16 items-center justify-center border-t border-neutral-200 bg-white text-center text-sm text-neutral-800 dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-400">
        &copy; {{ new Date().getFullYear() }} - ActiveEngagement, LLC <span class="bold px-2 text-2xl">&#10072;</span> Version {{ version }}
    </footer>
</template>